<div class="list-group">
    <button type="button" [routerLinkActive]="['active']" routerLink='/configuracion' class="list-group-item list-group-item-action">
      <div class="with-icon">
      <mat-icon class="padding-icon">settings_applications</mat-icon><span > Parametrización</span>
      </div>
    </button>

    <button type="button" [routerLinkActive]="['active']" routerLink='/empresa' class="list-group-item list-group-item-action">
      <div class="with-icon">
      <mat-icon class="padding-icon">apartment</mat-icon><span >Empresa</span>
      </div>
    </button>
</div>
